import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
import { Review } from './Review';
export function ProductSidebar() {
  return <div className="sticky top-24 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-81">
      <div className="p-4 bg-[#1E4D3D] text-white text-center" data-id="element-82">
        <h3 className="font-bold text-lg" data-id="element-83">Glisera Patch</h3>
        <p className="text-sm text-white/80" data-id="element-84">
          Calm Your Nervous System Naturally
        </p>
      </div>

      <div className="p-6" data-id="element-85">
        <div className="mb-4 relative group max-w-[200px] mx-auto" data-id="element-86">
          <img src="https://cdn.magicpatterns.com/uploads/gSSXetTbaofjctckKGEhVg/ChatGPT_Image_10_Ιαν_2026,_12_14_05_μ.μ..png" alt="Glisera Anti-Alcohol Patch box and patches" className="w-full h-auto rounded-lg transform group-hover:scale-105 transition-transform duration-300" data-id="element-87" />
        </div>

        <a href="https://thegliserastore.com/products/glissera-anti-alcohol-patch" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-3 px-4 rounded shadow-md transition-colors mb-4 flex items-center justify-center group" data-id="element-88">
          Check availability
          <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-89">
            {'>>'}
          </span>
        </a>

        <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 text-center" data-id="element-90">
          <div className="flex justify-center mb-2" data-id="element-91">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-92">
              <ShieldCheck className="w-8 h-8 text-blue-600" data-id="element-93" />
            </div>
          </div>
          <div className="font-bold text-sm text-gray-900 mb-1" data-id="element-94">
            60-Day Guarantee
          </div>
          <div className="flex justify-center items-center gap-1 mb-1" data-id="element-95">
            <div className="flex text-yellow-400" data-id="element-96">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-97" />)}
            </div>
          </div>
          <div className="text-sm font-bold text-gray-900" data-id="element-98">
            4.8 <span className="font-normal text-gray-500" data-id="element-99">/ 5.00</span>
          </div>
          <div className="text-xs text-gray-500" data-id="element-100">Based on 2,847 reviews</div>
        </div>

        <div className="space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar" data-id="element-101">
          <Review author="Mark T." location="Phoenix, AZ" content="After 15 years of nightly beers, I stopped wanting them in week one. My wife says she has her husband back." timeAgo="2 days ago" data-id="element-102" />
          <Review author="David K." location="Dallas, TX" content="The 3 AM wake-ups were destroying me. Heart racing, mind spinning. Now I sleep through the night. My anxiety is just... gone." timeAgo="5 days ago" data-id="element-103" />
          <Review author="Robert M." location="Seattle, WA" content="This patch did what nothing else could. Within 10 days the craving went from a 9 to a 2." timeAgo="1 week ago" data-id="element-104" />
        </div>

        <button className="w-full mt-4 text-xs text-blue-600 font-medium hover:underline border border-blue-100 rounded py-2 hover:bg-blue-50 transition-colors" data-id="element-105">
          View more reviews
        </button>
      </div>
    </div>;
}